<ui-popover
  #popover="ui-popover"
  [config]="popoverConfig">
  <ng-template ui-popover-template>
    <div class="content">
      <ns-popover-header />
      <div class="ui-scrollbar">
        <ns-notifications-list
          (linkClicked)="handleLinkClicked()"
          (notificationClicked)="handleNotificationClicked($event)" />
      </div>
    </div>
  </ng-template>
</ui-popover>
